import { useFormContext } from 'react-hook-form';
import colors from 'tailwindcss/colors';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { Autocomplete, DatePicker } from '@/modules/common';

import {
  eventAiOptions,
  EventStatusEnum,
  eventStatusOptions,
} from '../constants';

export function EventInfo() {
  const { control, watch } = useFormContext();
  const status = watch('status', EventStatusEnum.Active);

  return (
    <div className="gap-4 flex flex-col">
      <h3 className="text-2xl font-semibold text-zinc-50">Event Info</h3>
      <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:grid-cols-2 grid-flow-col grid-rows-6 sm:grid-rows-1">
        <FormField
          control={control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Event name</FormLabel>
              <FormControl>
                <Input placeholder="Add event name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <DatePicker control={control} name="startDate" label="Start date" />

        <Autocomplete
          name="aiModel"
          label="AI Model"
          control={control}
          placeholder="Select Ai model"
          options={eventAiOptions}
        />

        <Autocomplete
          name="status"
          label="Status"
          control={control}
          placeholder="Select status"
          options={eventStatusOptions}
          className={cn({
            'bg-green-500 hover:bg-green-500 text-zinc-900 hover:text-zinc-900':
              status === EventStatusEnum.Active,
            'bg-accent hover:bg-accent text-zinc-900 hover:text-zinc-900':
              status === EventStatusEnum.Archived,
          })}
          iconColor={colors.zinc[900]}
        />
      </div>
    </div>
  );
}
